<template>
  <!-- Floating preview switch for the redesigned nav/top-bar. Remove this
       (and the redesign folder) to retire the experiment. -->
  <button
    class="redesign-toggle"
    :class="[
      $i18n.locale === 'ar' ? 'redesign-toggle--start' : 'redesign-toggle--end',
      redesignEnabled ? 'redesign-toggle--on' : '',
    ]"
    title="Preview the redesigned nav & top bar"
    @click="toggleRedesign"
  >
    <v-icon size="16" :color="redesignEnabled ? '#ffffff' : '#0E3B3B'">
      mdi-palette-swatch-outline
    </v-icon>
    {{ redesignEnabled ? "Redesign: ON" : "Redesign: OFF" }}
  </button>
</template>

<script>
import { redesignEnabled, toggleRedesign } from "./redesignFlag";

export default {
  name: "RedesignToggle",
  setup() {
    return { redesignEnabled, toggleRedesign };
  },
};
</script>

<style scoped>
.redesign-toggle {
  position: fixed;
  bottom: 16px;
  z-index: 3000;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  color: #0e3b3b;
  background: #fff;
  border: 1px solid #dce5e3;
  box-shadow: 0 6px 20px -6px rgba(14, 59, 59, 0.4);
}
.redesign-toggle--on {
  color: #fff;
  background: #0e3b3b;
  border-color: #0e3b3b;
}
.redesign-toggle--end {
  right: 16px;
}
.redesign-toggle--start {
  left: 16px;
}
</style>
